import { render, staticRenderFns } from "./TeachOtoSetting.vue?vue&type=template&id=4b042355&scoped=true&"
import script from "./TeachOtoSetting.vue?vue&type=script&lang=js&"
export * from "./TeachOtoSetting.vue?vue&type=script&lang=js&"
import style0 from "./TeachOtoSetting.vue?vue&type=style&index=0&id=4b042355&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b042355",
  null
  
)

export default component.exports